export default "__VITE_ASSET__a76a5a02__"